import { reportMenus } from "./reportMenus";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const menus = {
  Master: [
    { name: "Bank Master",           path: "/master/bankmaster" },
    { name: "Buyer Bank Master",     path: "/master/buyerbankmaster" },
    { name: "Buyer Master",          path: "/master/buyermaster" },
    { name: "Contact Group Master",  path: "/master/contactgroupmaster" },
    { name: "Document Master",       path: "/master/documentmaster" },
    { name: "Forex Rate",            path: "/master/forexrate" },
    { name: "Item ISRI Master",      path: "/master/itemisrimaster" },
    { name: "Item Master",           path: "/master/itemmaster" },
    { name: "HSN Master", path: "/master/hsnmaster" },
    { name: "Port Master",           path: "/master/portmaster" },
    { name: "Shipper Master",        path: "/master/shippermaster" },
    { name: "Packing Master",        path: "/master/packingmaster" },
    { name: "User Type Master",      path: "/master/usertypemaster" },
    { name: "User Master",           path: "/master/usermaster" },
    { name: "User Rights",           path: "/master/userrights" },
    { name: "Credit / Debit",        path: "/master/credit-debit" },
    { name: "Commission",            path: "/master/commission" },
  ],
  Transaction: [
    { name: "Ongoing Deal", path: "/transaction/new-deal/list" },
    { name: "New Invoice", path: "/transaction/new-invoice/list" },
  ],
  Reports: reportMenus,
  "Crystal Reports": [
    { name: "Buyer Report",                    path: "/report/crystal-reports/buyer" },
    { name: "Shipper Report",                  path: "/report/crystal-reports/shipper" },
    { name: "SC Pending Report",               path: "/report/crystal-reports/sc-pending" },
    { name: "SC Detail Report",                path: "/report/crystal-reports/sc-detail" },
    { name: "FollowUp Detail Report",          path: "/report/crystal-reports/followup" },
    { name: "Fixation Notice Report",          path: "/report/crystal-reports/fixation-note" },
    { name: "Deal Fixation Notice Report",     path: "/report/crystal-reports/deal-fixation-note" },
    { name: "Commission Report",               path: "/report/crystal-reports/commission" },
    { name: "Shipment Pending Report",         path: "/report/crystal-reports/shipment-pending" },
    { name: "Copy Document Pending Report",    path: "/report/crystal-reports/copy-doc-pending" },
    { name: "Advance Pending Report",          path: "/report/crystal-reports/advance-pending" },
    { name: "Deal Status Report",              path: "/report/crystal-reports/deal-status" },
    { name: "Sales Report",                    path: "/report/crystal-reports/sales" },
    { name: "Shipment Due Report",             path: "/report/crystal-reports/shipment-due" },
    { name: "Sales Contract Due Report",       path: "/report/crystal-reports/sales-contract-due" },
    { name: "Document Release Pending Report", path: "/report/crystal-reports/doc-release-pending" },
    { name: "Invoice List Report",             path: "/report/crystal-reports/invoice-list" },
    { name: "Pending Invoice Report",          path: "/report/crystal-reports/pending-invoice" },
    { name: "Shipment Advice Report",          path: "/report/crystal-reports/shipment-advice" },
    { name: "Bill Of Lading Report",           path: "/report/crystal-reports/bill-of-lading" },
    { name: "Inward Remittance Report",        path: "/report/crystal-reports/inward-remittance" },
    { name: "Payment Advice Report",           path: "/report/crystal-reports/payment-advice" },
    { name: "Sales Turnover Report",           path: "/report/crystal-reports/sales-turnover" },
    { name: "Weight Report",                   path: "/report/crystal-reports/weight" },
    { name: "Quality Report",                  path: "/report/crystal-reports/quality" },
    { name: "Document Dispatch Advice Report", path: "/report/crystal-reports/document-dispatch-advice" },
    { name: "Internal Invoice Report",         path: "/report/crystal-reports/internal-invoice" },
    { name: "Final Buyer Report",              path: "/report/crystal-reports/final-buyer" },
    { name: "Full Buyer Detail Report",        path: "/report/crystal-reports/full-buyer-detail" },
    { name: "Full Shipper Detail Report",      path: "/report/crystal-reports/full-shipper-detail" },
    { name: "Common Fixation Report",          path: "/report/crystal-reports/common-fixation" },
    { name: "Supplier Statement Report",       path: "/report/crystal-reports/supplier-statement" },
    { name: "External Supplier Statement Report", path: "/report/crystal-reports/external-supplier-statement" },
    { name: "Buyer Detail Report",             path: "/report/crystal-reports/buyer-detail" },
    { name: "Shipper Detail Report",           path: "/report/crystal-reports/shipper-detail" },
    { name: "Sales Contract Pending Report",   path: "/report/crystal-reports/sales-contract-pending" },
    { name: "Deal Status Revised Report",      path: "/report/crystal-reports/deal-status-revised" },
    { name: "Invoice Report",                  path: "/report/crystal-reports/invoice" },
    { name: "Buyer Summary Report",            path: "/report/crystal-reports/buyer-summary" },
    { name: "Buyer Contact Detail Report",     path: "/report/crystal-reports/buyer-contact-detail" },
    { name: "Buyer Dtl Report",                path: "/report/crystal-reports/buyer-dtl" },
    { name: "Buyer Detail Test Report",        path: "/report/crystal-reports/buyer-detail-test" },
    { name: "Buyer Detail Label Report",       path: "/report/crystal-reports/buyer-detail-label" },
    { name: "Shipper Summary Report",          path: "/report/crystal-reports/shipper-summary" },
    { name: "Shipper Contact Detail Report",   path: "/report/crystal-reports/shipper-contact-detail" },
    { name: "Shipper Dtl Report",              path: "/report/crystal-reports/shipper-dtl" },
    { name: "Shipper Detail Label Report",     path: "/report/crystal-reports/shipper-detail-label" },
    { name: "Shipper Test Report",             path: "/report/crystal-reports/shipper-test" },
  ],
  Tools: [
    { name: "Grid Settings", path: "/tools/grid-settings" },
    { name: "Company Setting",  path: "/tools/company-setting" },
    { name: "Year Setting",     path: "/tools/year-setting" },
    { name: "Database Detail",  path: "/tools/database-detail" },
  ],
};

const Sidebar = () => {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(() => {
    // auto-open the section that matches current path
    for (const [section, items] of Object.entries(menus)) {
      if (items.flatMap(i => i.children || [i]).some(i => location.pathname.startsWith(i.path.replace("/list", "")))) return section;
    }
    return "Dashboard";
  });

  const toggle = (menu) => setOpenMenu(prev => prev === menu ? null : menu);

  return (
    <div className="erp-sidebar-inner" style={{
      width: "100%",
      minHeight: "100vh",
      backgroundColor: "#17324d",
      color: "#ecf0f1",
      display: "flex",
      flexDirection: "column",
      overflowY: "auto",
    }}>
      {/* Brand */}
      <div style={{
        padding: "13px 14px",
        fontSize: "13px",
        fontWeight: "bold",
        letterSpacing: "0.5px",
        borderBottom: "1px solid #3d566e",
        color: "#a8d5a2",
      }}>
        GLOBAL METALS
      </div>

      {/* Menu sections */}
      <Link to="/dashboard" onClick={() => setOpenMenu(null)} style={{
        display: "block", padding: "8px 12px", fontWeight: "600", fontSize: "12px",
        letterSpacing: "0.6px", textTransform: "uppercase", textDecoration: "none",
        color: location.pathname === "/dashboard" ? "#a8d5a2" : "#ecf0f1",
        borderLeft: location.pathname === "/dashboard" ? "3px solid #a8d5a2" : "3px solid transparent"
      }}>Dashboard</Link>
      {Object.entries(menus).map(([section, items]) => {
        const isOpen = openMenu === section;
        return (
          <div key={section}>
            {/* Section header */}
            <div
              onClick={() => toggle(section)}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px 12px",
                cursor: "pointer",
                fontWeight: "600",
                fontSize: "12px",
                letterSpacing: "0.6px",
                textTransform: "uppercase",
                backgroundColor: isOpen ? "#1a252f" : "transparent",
                borderLeft: isOpen ? "3px solid #a8d5a2" : "3px solid transparent",
                transition: "all 0.2s",
                userSelect: "none",
              }}
              onMouseEnter={e => { if (!isOpen) e.currentTarget.style.backgroundColor = "#34495e"; }}
              onMouseLeave={e => { if (!isOpen) e.currentTarget.style.backgroundColor = "transparent"; }}
            >
              <span>{section}</span>
              <span style={{ fontSize: "10px", opacity: 0.7 }}>{isOpen ? "▲" : "▼"}</span>
            </div>

            {/* Sub-items */}
            {isOpen && (
              <div style={{ backgroundColor: "#1e2d3d" }}>
                {items.map(item => {
                  if (item.children) return <details key={item.name} open={item.children.some(child => child.path === location.pathname)} className="erp-report-sidebar-group">
                    <summary>{item.name}</summary>
                    {item.children.map(child => <Link key={child.path} to={child.path} aria-current={location.pathname === child.path ? "page" : undefined}>{child.name}</Link>)}
                  </details>;
                  const active = location.pathname === item.path;
                  return (
                    <Link
                      key={item.path}
                      to={item.path}
                      style={{
                        display: "block",
                        padding: "6px 12px 6px 20px",
                        fontSize: "12px",
                        color: active ? "#a8d5a2" : "#bdc3c7",
                        textDecoration: "none",
                        borderLeft: active ? "3px solid #a8d5a2" : "3px solid transparent",
                        backgroundColor: active ? "#16202a" : "transparent",
                        lineHeight: "1.4",
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                        transition: "all 0.15s",
                      }}
                      onMouseEnter={e => { if (!active) { e.currentTarget.style.backgroundColor = "#243342"; e.currentTarget.style.color = "#ecf0f1"; }}}
                      onMouseLeave={e => { if (!active) { e.currentTarget.style.backgroundColor = "transparent"; e.currentTarget.style.color = "#bdc3c7"; }}}
                    >
                      {item.name}
                    </Link>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Sidebar;
